import React from "react";
import Intro from "./Intro.js";
export default Intro;